// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".drop-zone__body[data-v-5a8c4658]{background-color:rgba(0,0,0,.45);position:sticky;top:0;z-index:2;height:calc(100vh - var(--drop-zone-indents-height));display:flex;flex-direction:column;align-items:center;justify-content:center;color:#fff;font-size:36px;border-radius:8px;border:2px dashed #fff}.drop-zone__text[data-v-5a8c4658]{margin-top:10px}.drop-zone__icon[data-v-5a8c4658]{font-size:80px}", ""]);
// Exports
module.exports = exports;
